/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgHeart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M14.557 2.61a6.25 6.25 0 018.645 5.776 6.25 6.25 0 01-1.832 4.42l-8.84 8.84a.75.75 0 01-1.06 0l-8.84-8.84a6.251 6.251 0 018.84-8.84l.53.53.53-.53a6.25 6.25 0 012.027-1.356zm2.393 1.024a4.75 4.75 0 00-3.36 1.392l-1.06 1.06a.75.75 0 01-1.06 0l-1.06-1.06a4.751 4.751 0 10-6.72 6.72l8.31 8.31 8.31-8.31a4.751 4.751 0 00-3.36-8.112z'
      />
    </svg>
  );
}

export default SvgHeart;
